module.exports = __webpack_public_path__ + "static/img/products_normal_mobile.81406eba.jpg";